/**
 * Holds e.g. QR code data after selecting Payconic, or 3DS data after selecting credit card.
 */
export const LOCAL_STORAGE_ADYEN_ACTION = 'adyenAction';

/**
 * Holds result information of the adyen component.
 */
export const LOCAL_STORAGE_ADYEN_STATE = 'adyenState';

/**
 * Holds user input for a payments from the payment selection step, e.g. encrypted credit card data.
 * @see utils/adyen.js for how it's used.
 */
export const LOCAL_STORAGE_ADYEN_PAYLOAD = 'adyenPayload';
export const LOCAL_STORAGE_DELIVERY_OPTION = 'deliveryOption';
export const LOCAL_STORAGE_PICKUP_DELIVERY_ADDRESS = 'pickupDeliveryAddress';

export function getFromLocalStorage(storageKey: string) {
  if (import.meta.server) {
    return null;
  }

  const storedData = localStorage.getItem(storageKey);

  if (!storedData) {
    return null;
  }

  try {
    return JSON.parse(storedData);
  } catch (error) {
    return null;
  }
}

export function saveToLocalStorage(storageKey: string, data: Record<string, any>) {
  if (import.meta.server) {
    return;
  }

  const storedData = getFromLocalStorage(storageKey);

  localStorage.setItem(storageKey, JSON.stringify({ ...storedData, ...data }));
}

export function deleteFromLocalStorage(storageKey: string) {
  if (import.meta.server) {
    return;
  }

  localStorage.removeItem(storageKey);
}
